
import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import Group from 'model/Group'

export class GroupRepository extends WebRepository<Group> {
  constructor() {
    super(new Api('groups'))
  }

}

export default new GroupRepository()
